import React, { FC } from 'react';
import { Paper, Box } from '@mui/material';
import { invoiceDateVar } from 'apollo/reactive-variables/invoice';
import { useTranslation } from 'react-i18next';
import { formatCurrency, formatDate } from 'utils/format';

type InvoiceCompilationProps = {
    totalValue: Record<string, number>;
};

const InvoiceCompilation: FC<InvoiceCompilationProps> = ({ totalValue }: InvoiceCompilationProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);
    return (
        <Paper square variant="outlined">
            <Box p={2}>
                <div>
                    <strong>{translate('invoices:INVOICE_DATE')}:&nbsp;</strong>
                    {formatDate(invoiceDateVar().invoiceDate, 'date')}
                </div>
                <div>
                    <strong>{translate('invoices:ORDERS_READY_FOR')}:&nbsp;</strong>
                    {formatDate(invoiceDateVar().orderToDate, 'date')}
                </div>

                <div style={{ display: 'flex' }}>
                    <strong>{translate('invoices:TOTAL_VALUE')}:&nbsp;</strong>
                    <div>
                        {Object.keys(totalValue).map((currency: string) => (
                            <div key={currency}>{formatCurrency(totalValue[currency], currency)}</div>
                        ))}
                    </div>
                </div>
            </Box>
        </Paper>
    );
};

export default InvoiceCompilation;
